export function getUrlQueryParam(param) {
    const url = new URL(window.location.toString());
    return url.searchParams.get(param);
}
export function getFileExtenstionFromUrl(url) {
    return (url.match(/\.([^.]*?)(?=\?|#|$)/) || [])[1];
}
